import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { LoadingState } from './States';

const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  if (auth.status === 'loading') return <main className="centered-page"><LoadingState label="Verifying your identity…" /></main>;
  if (auth.status === 'denied') return <Navigate to="/access-denied" replace />;
  if (auth.status !== 'authorized') return <Navigate to="/" replace />;
  return children;
};
export default ProtectedRoute;
